<template>
    <transition name="move-to-left">
        <div
            v-if="isHelpPanelOpen"
            :class="`absolute h-dvh w-[505px] max-w-[100vw] max-h-dvh top-0 right-0 z-[101] bg-white shadow-lg font-caption move-to-left-start`"
        >
            <focus-lock :disabled="disabled" class="h-full">
                <div class="bg-white h-full flex flex-col">
                    <div class="
                      mx-[24px]

                      sm:mx-[40px]

                      py-[64px] text-[24px] font-semibold uppercase flex justify-between items-center border-b border-gray-300 h-[158px]
                    ">
                        <div>{{ $t('HELP_SECTION') }}</div>
                        <button @click="closeHelpPanel" class="focus-outline-only rounded">
                            <close-icon class="size-[16px]" />
                        </button>
                    </div>
                    <div class="flex flex-col flex-1 text-[18px] relative">
                        <transition name="cz3__fade">
                            <div
                                v-if="activeContent === activeContentOptions.MENU"
                                class="absolute top-0 left-0 size-full pt-[40px]"
                            >
                                <button
                                    @click="activeContent = activeContentOptions.MAIN_CONTENT"
                                    class="
                                      block text-gray-dark leading-[20px] p-[16px]

                                      sm:mx-[24px]

                                      mx-[16px] mb-[16px] cursor-pointer rounded-[4px] focus-outline-only

                                      hover:bg-gray-200
                                    ">
                                    {{ $t('DESIGN_HELP') }}
                                </button>
                                <button
                                    @click="activeContent = activeContentOptions.CONTACT_US"
                                    class="
                                      block text-gray-dark leading-[20px] p-[16px]

                                      sm:mx-[24px]

                                      mx-[16px] mb-[16px] cursor-pointer rounded-[4px] focus-outline-only

                                      hover:bg-gray-200
                                    ">
                                    {{ $t('CONTACT_US') }}
                                </button>
                            </div>
                            <div v-else-if="activeContent === activeContentOptions.MAIN_CONTENT"
                                class="absolute top-0 left-0 size-full px-[40px] overflow-y-auto max-h-[calc(100dvh-158px-114px)] pt-[40px]"
                            >
                                <help-panel-main-content />
                            </div>
                            <div v-else-if="activeContent === activeContentOptions.CONTACT_US"
                                class="absolute top-0 left-0 size-full px-[40px] my-[12px] overflow-y-auto max-h-[calc(100dvh-158px-114px)] pt-[40px]"
                            >
                                <help-panel-contact-us />
                            </div>
                        </transition>
                        <div class="flex-1 border-b border-gray-300"></div>
                        <div class="p-[32px] z-10 bg-white">
                            <button
                                class="w-full bg-gray-200 rounded-[4px] text-gray-darker font-semibold text-[16px] py-[16px] cursor-pointer focus-outline-only"
                                width="100%"
                                @click="navigateBack"
                            >
                                {{ $t('BACK') }}
                            </button>
                        </div>
                    </div>
                </div>
            </focus-lock>
        </div>
    </transition>
</template>

<script>
    import FocusLock from 'vue-focus-lock';

    import allStores from '../../../stores/all';

    import CloseIcon from '../../icons/CloseIcon.vue';

    import HelpPanelMainContent from './HelpPanelMainContent.vue';
    import HelpPanelContactUs from './HelpPanelContactUs.vue';

    const activeContentOptions = {
        MENU: 'MENU',
        MAIN_CONTENT: 'MAIN_CONTENT',
        CONTACT_US: 'CONTACT_US',
    };

    export default {
        components: {
            FocusLock,
            CloseIcon,
            HelpPanelMainContent,
            HelpPanelContactUs,
        },
        name: 'HelpPanel',

        mixins: [allStores],

        data() {
            return {
                disabled: true,
                activeContentOptions,
                activeContent: activeContentOptions.MENU,
            };
        },

        computed: {
            isHelpPanelOpen() {
                return this.customizerStore.isHelpPanelOpen;
            },
        },

        watch: {
            isHelpPanelOpen(newValue) {
                if (newValue) {
                    // Enable focus lock after the animation.
                    setTimeout(() => {
                        this.disabled = false;

                        this.lastFocused = document.activeElement;

                        const firstButton = this.$el.querySelector('button');
                        firstButton?.focus();
                    }, 500);
                } else {
                    // If hiding, disable right away.
                    this.disabled = true;

                    this.lastFocused?.focus();
                }
            },
        },

        methods: {
            closeHelpPanel() {
                this.customizerStore.closeHelpPanel();

                if (this.activeContent !== activeContentOptions.MENU) {
                    this.activeContent = activeContentOptions.MENU;
                }
            },

            navigateBack() {
                switch (this.activeContent) {
                case activeContentOptions.MENU:
                    this.closeHelpPanel();
                    break;

                case activeContentOptions.MAIN_CONTENT:
                    this.activeContent = activeContentOptions.MENU;
                    break;

                case activeContentOptions.CONTACT_US:
                    this.activeContent = activeContentOptions.MENU;
                    break;

                default:
                    this.activeContent = activeContentOptions.MENU;
                    break;
                }
            },
        },
    };
</script>
